import { render } from "./ItemDetail.vue?vue&type=template&id=4e8a0d3e&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"

import "./ItemDetail.vue?vue&type=style&index=0&id=4e8a0d3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8a0d3e"]])

export default __exports__